import React from 'react';
import PropTypes from 'prop-types';
import { changeFilter } from '../../common/services/navigation';
// function jipStatusFilterDropdown({search, isYear, settings, dateSpan}) {

function StatusFilterDropdown({search}) {
    //const s = settings;

    // let monthNames = [ 'January', 'February', 'March', 'April', 'May', 'June',
    //     'July', 'August', 'September', 'October', 'November', 'December' ];    


    
    // let years = Array(5).fill(new Date().getFullYear());

    // if (dateSpan)
    // {
    //     years = Array(dateSpan+1).fill(new Date().getFullYear());
    // }
        
    // let dropdown;
    // // let clsName = 'filter filter__dropdown filter__small';
    // // if(s.appId == 'ourstories'){
    // //     clsName = 'filter filter__dropdown';
    // // }


    // let dropdown = <jipStatusFilterDropdownItem search={search} title={status} options={status} />;

    let status = ['Completed', 'Project', 'Proposal'];

    const change = e => {
		changeFilter(search, 'status', e.target.value);
	};
     
	return (
        // <div className='filter filter__dropdown filter__small'>
        //     {dropdown}
        // </div>

        <div className='filter__dropdown'>
            <label className="visuallyhidden" htmlFor='Status'>Project Status</label>
            <select id='Status' name='Status' value={search['status']} onChange={change} className="filter__element">
                <option value="">Project Status...</option>
                {status.map((key, index) => (<option key={index} value={key}>{key}</option>))}
            </select>
        </div>	

	);
}

StatusFilterDropdown.propTypes = {
    search: PropTypes.object,

};

export default StatusFilterDropdown;